// https://stackoverflow.com/a/63763497
export const getInitials = (name: string | undefined) =>
  name
    ?.match(/(\b\S)?/g)
    ?.join('')
    .match(/(^\S|\S$)?/g)
    ?.join('')
    .toUpperCase()
